// Facility utility functions for consistent service and infrastructure counting

// Key health services to count across all views
export const KEY_HEALTH_SERVICES = [
  'immunization_services',
  'maternal_and_child_health_services',
  'hivaids_and_tb_care',
  'basic_diagnostic_services',
  'family_planning_services',
]

// All health services for detailed modal
export const ALL_HEALTH_SERVICES = [
  { id: 'immunization_services', name: 'Immunization Services', icon: '💉' },
  {
    id: 'maternal_and_child_health_services',
    name: 'Maternal & Child Health',
    icon: '👶',
  },
  { id: 'hivaids_and_tb_care', name: 'HIV/AIDS & TB Care', icon: '🏥' },
  {
    id: 'basic_diagnostic_services',
    name: 'Basic Diagnostic Services',
    icon: '🔬',
  },
  { id: 'counselling', name: 'Counselling', icon: '💬' },
  { id: 'health_education', name: 'Health Education', icon: '📚' },
  { id: 'family_planning_services', name: 'Family Planning', icon: '👪' },
  { id: 'advanced_surgical_procedures', name: 'Advanced Surgery', icon: '⚕️' },
  { id: 'outpatient_services', name: 'Outpatient Services', icon: '🚪' },
]

// Key infrastructure items
export const KEY_INFRASTRUCTURE = [
  'laboratory',
  'treatment_room',
  'consulting_room',
  'functional_backup_power',
]

// All infrastructure items for detailed modal
export const ALL_INFRASTRUCTURE = [
  { id: 'functional_backup_power', name: 'Backup Power', icon: '⚡' },
  { id: 'laboratory', name: 'Laboratory', icon: '🧪' },
  { id: 'treatment_room', name: 'Treatment Room', icon: '🏥' },
  { id: 'consulting_room', name: 'Consulting Room', icon: '💺' },
  { id: 'staff_accommodation', name: 'Staff Housing', icon: '🏠' },
  { id: 'reception', name: 'Reception Area', icon: '🏢' },
  { id: 'waste_disposal_incinerator', name: 'Waste Disposal', icon: '♻️' },
  { id: 'gate', name: 'Security Gate', icon: '🚪' },
  { id: 'delivery_room', name: 'Delivery Room', icon: '🤱' },
  { id: 'inpatient_ward', name: 'Inpatient Ward', icon: '🛏️' },
]

// Count key services (consistent across all views)
export function countKeyServices(facility) {
  if (!facility) return 0

  return KEY_HEALTH_SERVICES.filter(service => facility[service] === 'Yes')
    .length
}

// Count key infrastructure (consistent across all views)
export function countKeyInfrastructure(facility) {
  if (!facility) return 0

  return KEY_INFRASTRUCTURE.filter(item => facility[item] === 'Yes').length
}

// Get all available services for detailed view
export function getAvailableServices(facility) {
  if (!facility) return []

  return ALL_HEALTH_SERVICES.filter(service => facility[service.id] === 'Yes')
}

// Get all available infrastructure for detailed view
export function getAvailableInfrastructure(facility) {
  if (!facility) return []

  return ALL_INFRASTRUCTURE.filter(item => facility[item.id] === 'Yes')
}
